import { Outlet, useMatches } from 'react-router-dom'
import { NeuralCanvas } from '@/components/NeuralCanvas'
import { cn } from '@/lib/cn'

type AuthRouteHandle = { authWide?: boolean }

/**
 * Wraps the unauthenticated routes (/app/login, /app/signup, /app/forgot-password,
 * etc.) with the brand canvas backdrop and a centered card. Pages drop
 * straight into <Outlet/> with their own form markup. When a route sets
 * `handle.authWide = true` the max-width cap is lifted so the page can
 * render a two-column split (form + trust panel).
 */
export function AuthLayout() {
  const matches = useMatches() as Array<{ handle?: AuthRouteHandle }>
  const wide = matches.some((m) => m.handle?.authWide)

  return (
    <div className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-background px-4 py-8">
      <NeuralCanvas />
      <div className={cn('relative z-10 w-full', wide ? 'max-w-5xl' : 'max-w-md')}>
        <Outlet />
      </div>
    </div>
  )
}
